import type { SVGProps, ReactElement } from 'react';

export function ErrorIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6.75 6.75a.75.75 0 1 1-1.5 0V3a.75.75 0 1 1 1.5 0v3.75zm-.75 3a.75.75 0 1 1-.001-1.499A.75.75 0 0 1 6 9.75zm5.51-4.933L7.183.49a1.673 1.673 0 0 0-2.366 0L.49 4.817a1.673 1.673 0 0 0 0 2.366l4.327 4.327a1.673 1.673 0 0 0 2.366 0l4.327-4.327a1.673 1.673 0 0 0 0-2.366z" />
    </svg>
  );
}
